// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3Ur_2","col":"Table_col__xVkNI","fulfillmentStatus":"Table_fulfillmentStatus__2c5Yk","emailCol":"Table_emailCol__2u0L-"};